(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2590],{

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ FormSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/Select.tsx
var Select = __webpack_require__(2679);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./components/form/FormSelect/FormSelect.tsx






var FormSelect = function(param) {
    var name = param.name, options = param.options, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input;
    var ref, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, errors = ref2.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formGroup), {
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: name,
            render: function(param) {
                var field = param.field;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    id: name,
                    options: options,
                    type: "text",
                    variant: (errors === null || errors === void 0 ? void 0 : errors[name]) ? "error" : ""
                }, input, field), {
                    value: field.value || ""
                }));
            }
        })
    }));
};

;// CONCATENATED MODULE: ./components/form/FormSelect/index.ts



/***/ }),

/***/ 92132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PQ": function() { return /* binding */ StyledContainer; },
/* harmony export */   "SD": function() { return /* binding */ StyledWrapper; },
/* harmony export */   "eb": function() { return /* binding */ StyledHeader; }
/* harmony export */ });
/* unused harmony exports StyledForm, StyledFormTitle, StyledFormInputs, StyledFormTerms */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17975);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  line-height: 1.6;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: ",
        " auto 0;\n\n  ",
        " {\n    position: absolute;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.1666;\n  font-weight: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 19.25rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  button {\n    align-self: flex-start;\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n  margin-top: 0;\n  margin-bottom: 0;\n\n  a {\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n    }\n\n    &:active {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a34d7a34-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_800"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default_inverse"));
var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a34d7a34-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a34d7a34-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"));
var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-a34d7a34-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl3"), components_shared_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledFormGroupError */ .jN);
var StyledFormTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-a34d7a34-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("extraBold"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"));
var StyledFormInputs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a34d7a34-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"));
var StyledFormTerms = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-a34d7a34-6"
})(_templateObject6(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_hover"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_active"));


/***/ }),

/***/ 65602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer_TalentEngineFooter; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/form/FormCheckbox/index.ts + 1 modules
var FormCheckbox = __webpack_require__(74806);
// EXTERNAL MODULE: ./components/form/FormPhone/index.ts + 1 modules
var FormPhone = __webpack_require__(72109);
// EXTERNAL MODULE: ./components/form/FormSelect/index.ts + 1 modules
var FormSelect = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./components/form/FormTextarea/index.ts + 1 modules
var FormTextarea = __webpack_require__(13573);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./features/portal/v2/contact/basic-info/ContactBasicInfo.constants.ts
var ContactBasicInfo_constants = __webpack_require__(18032);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.deal.ts
var service_deal = __webpack_require__(75399);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var dist_esm = __webpack_require__(74679);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../api-common/dist/esm/index.js + 114 modules
var api_common_dist_esm = __webpack_require__(25465);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/form/Form.constants.ts




var I18N_PREFIX = "companies2:companies";
var DEFAULT_TYPE_OPTION = {
    label: "SELECT_ONE",
    value: ""
};
var CompaniesFormFieldsSchema = lib.z.object({
    name: lib.z.string(),
    email: lib.z.string(),
    description: lib.z.string(),
    company: lib.z.string(),
    howDoYouKnowUs: lib.z["enum"](api_common_dist_esm/* howDoYouKnowUsValues */.TwG),
    contactPhone: lib.z.string().optional(),
    terms: lib.z.boolean().optional(),
    isSubscribeToNewsletter: lib.z.boolean()
});
var CompaniesFormFieldsValidationSchema = CompaniesFormFieldsSchema.partial()// Name required
.refine(function(schema) {
    return !!schema.name;
}, {
    path: [
        "name"
    ],
    message: "".concat(I18N_PREFIX, ".form.required-name")
})// Email required
.refine(function(schema) {
    return !!schema.email;
}, {
    path: [
        "email"
    ],
    message: "".concat(I18N_PREFIX, ".form.required-email")
})// Email format
.refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(dist_esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: "".concat(I18N_PREFIX, ".form.invalid-email")
})// Description required
.refine(function(schema) {
    return !!schema.description;
}, {
    path: [
        "description"
    ],
    message: "".concat(I18N_PREFIX, ".form.required-description")
})// How do you know us required
.refine(function(schema) {
    return !!schema.howDoYouKnowUs;
}, {
    path: [
        "howDoYouKnowUs"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-how-do-you-know-us"), {
        ns: I18N_PREFIX
    })
})// company required
.refine(function(schema) {
    return !!schema.company;
}, {
    path: [
        "company"
    ],
    message: "".concat(I18N_PREFIX, ".form.required-company")
});
var FORM_FIELDS_DEFAULT_VALUES = {
    name: "",
    email: "",
    description: "",
    company: "",
    contactPhone: "",
    howDoYouKnowUs: undefined,
    isSubscribeToNewsletter: false
};

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/form/Form.hooks.ts













var useCompaniesForm = function() {
    var t = (0,useI18n/* useI18n */.Q)("companies2").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,useToasts/* useToasts */.e)(), addErrorToast = ref.addErrorToast, addSuccessToast = ref.addSuccessToast;
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: FORM_FIELDS_DEFAULT_VALUES,
        resolver: (0,zod/* zodResolver */.F)(CompaniesFormFieldsValidationSchema)
    });
    var isTermsAccepted = !!formMethods.watch("terms");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            service_deal/* ServiceDeal.create */.a.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                howDoYouKnowUs: data.howDoYouKnowUs || "OTHER",
                                source: "Manfred Web",
                                consultingOptions: []
                            }))
                        ];
                    case 1:
                        _state.sent();
                        formMethods.reset(FORM_FIELDS_DEFAULT_VALUES);
                        addSuccessToast(t("companies.form.success"));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        console.error("There was an error while submitting the Companies form. Form data: ".concat(data, ". Exception: ").concat(ex));
                        addErrorToast(t("companies.form.error"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        addSuccessToast,
        formMethods,
        t
    ]);
    var onFormFieldFocus = (0,react.useCallback)(function() {
        service_event_tracking/* default.track */.Z.track({
            type: "Landing - Form Focused",
            properties: {
                objectName: "contacto-empresas",
                url: window.location.href,
                urlParams: new URLSearchParams(window.location.search).toString()
            }
        });
    }, []);
    return {
        t: t,
        locale: locale,
        formMethods: formMethods,
        onSubmit: onSubmit,
        isTermsAccepted: isTermsAccepted,
        onFormFieldFocus: onFormFieldFocus
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/form/Form.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  position: relative;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n  max-width: 34rem;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n\n  .phoneNumber {\n    max-width: 20rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n  font-size: ",
        ";\n\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n\n  a {\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n    }\n\n    &:active {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: absolute;\n  inset: 0;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n\n  .astronaut {\n    object-fit: contain;\n    margin-top: auto;\n    height: 32rem;\n    margin-right: -3rem;\n    margin-bottom: 2rem;\n    transform: translateY(0);\n    animation: float 6s ease-in-out infinite;\n  }\n\n  .planet {\n    object-fit: contain;\n    height: 15.625rem;\n    transform: translateY(0);\n    margin-left: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  @keyframes float {\n    0% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(20px);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-419d0162-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var StyledContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-419d0162-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-419d0162-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledTerms = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-419d0162-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"));
var StyledHeroImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-419d0162-4"
})(_templateObject4(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/form/Form.utils.ts





var getTypeOptions = function(t) {
    var options = api_common_dist_esm/* howDoYouKnowUsValues.map */.TwG.map(function(h) {
        return {
            label: h,
            value: h
        };
    });
    return [
        DEFAULT_TYPE_OPTION
    ].concat((0,_to_consumable_array/* default */.Z)(options)).map(function(type) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, type), {
            label: t("companies.form.how-do-you-know-us-values.".concat(type.label))
        });
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/form/Form.tsx


















var Form = function() {
    var ref = useCompaniesForm(), t = ref.t, formMethods = ref.formMethods, locale = ref.locale, onSubmit = ref.onSubmit, isTermsAccepted = ref.isTermsAccepted, onFormFieldFocus = ref.onFormFieldFocus;
    var handleSubmit = formMethods.handleSubmit, isSubmitting = formMethods.formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                        name: "name",
                        formGroup: {
                            label: t("companies.form.name")
                        },
                        input: {
                            placeholder: t("companies.form.name_placeholder"),
                            onFocus: onFormFieldFocus
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                        name: "email",
                        formGroup: {
                            label: t("companies.form.email")
                        },
                        input: {
                            placeholder: t("companies.form.email_placeholder"),
                            onFocus: onFormFieldFocus
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "phoneNumber",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormPhone/* FormPhone */.J, {
                            name: "contactPhone",
                            formGroup: {
                                label: t("companies.form.phone")
                            },
                            input: {
                                defaultCountry: ContactBasicInfo_constants/* PHONE_NUMBER_DEFAULT_COUNTRY */.r,
                                onFocus: onFormFieldFocus
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                        name: "company",
                        formGroup: {
                            label: t("companies.form.company")
                        },
                        input: {
                            placeholder: t("companies.form.company_placeholder"),
                            onFocus: onFormFieldFocus
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* FormSelect */.i, {
                        name: "howDoYouKnowUs",
                        formGroup: {
                            label: t("companies.form.how-do-you-know-us")
                        },
                        options: getTypeOptions(t)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextarea/* FormTextarea */.B, {
                        name: "description",
                        formGroup: {
                            label: t("companies.form.description")
                        },
                        input: {
                            placeholder: t("companies.form.description_placeholder"),
                            onFocus: onFormFieldFocus,
                            rows: 3
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                        name: "terms",
                        input: {
                            onFocus: onFormFieldFocus,
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTerms, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    ns: "companies2",
                                    i18nKey: "companies.form.terms",
                                    components: {
                                        privatePolicy: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy, locale)
                                        }),
                                        terms: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse, locale)
                                        })
                                    }
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                        name: "isSubscribeToNewsletter",
                        input: {
                            onFocus: onFormFieldFocus,
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTerms, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    ns: "companies2",
                                    i18nKey: "companies.form.newsletter",
                                    components: {
                                        newsletter: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://none.clickacm.com/show/qgJ2lZXPBBizIfJi3pmS/",
                                            target: "_blank"
                                        })
                                    }
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                        schema: "brand2",
                        label: t("companies.form.submit"),
                        startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                        type: "submit",
                        disabled: !isTermsAccepted,
                        isLoading: isSubmitting,
                        loadingText: t("companies.form.submit_in-progress")
                    })
                ]
            }))
        })
    });
};
/* harmony default export */ var form_Form = (Form);

// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ./utils/fetch.ts
var fetch = __webpack_require__(89608);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.types.ts


var TalentEngineFormFieldsSchema = lib.z.object({
    name: lib.z.string().nonempty({
        message: "talent-engine-landing-v3:talent-engine-landing.form.messages.name_required"
    }),
    company: lib.z.string().nonempty({
        message: "talent-engine-landing-v3:talent-engine-landing.form.messages.company_required"
    }),
    email: lib.z.string().nonempty({
        message: "talent-engine-landing-v3:talent-engine-landing.form.messages.email_required"
    })
}).refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(dist_esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: "talent-engine-landing-v3:talent-engine-landing.form.messages.email_invalid"
});

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.hooks.ts











var useTalentEngineFooter = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    var ref = (0,useToasts/* useToasts */.e)(), addErrorToast = ref.addErrorToast, addSuccessToast = ref.addSuccessToast;
    var DEFAULT_FORM_VALUES = (0,react.useMemo)(function() {
        return {
            name: "",
            company: "",
            email: ""
        };
    }, []);
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: DEFAULT_FORM_VALUES,
        mode: "onBlur",
        reValidateMode: "onBlur",
        resolver: (0,zod/* zodResolver */.F)(TalentEngineFormFieldsSchema)
    });
    var isFormFilled = !!formMethods.watch("name") && !!formMethods.watch("company") && !!formMethods.watch("email");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch/* post */.v_("/api/teca", data)
                        ];
                    case 1:
                        _state.sent();
                        service_event_tracking/* default.track */.Z.track({
                            type: "Landing - Form Submitted",
                            properties: {
                                objectName: "talent-engine-demo",
                                formContent: {
                                    name: data.name,
                                    company: data.company,
                                    email: data.email
                                }
                            }
                        });
                        addSuccessToast(t("talent-engine-landing.form.messages.submit_success"));
                        formMethods.reset(DEFAULT_FORM_VALUES);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        addErrorToast(t("talent-engine-landing.form.messages.submit_success", {
                            error: (0,errors/* getErrorMessage */.e)(ex)
                        }), t("talent-engine-landing.form.messages.submit_error"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        DEFAULT_FORM_VALUES,
        addErrorToast,
        addSuccessToast,
        formMethods,
        t
    ]);
    var onFormFieldFocus = (0,react.useCallback)(function() {
        service_event_tracking/* default.trackLandingFormFocused */.Z.trackLandingFormFocused("talent-engine-demo");
    }, []);
    return {
        t: t,
        onSubmit: onSubmit,
        formMethods: formMethods,
        isFormFilled: isFormFilled,
        onFormFieldFocus: onFormFieldFocus
    };
};

// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.styled.tsx
var TalentEngineFooter_styled = __webpack_require__(92132);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.tsx








var TalentEngineFooter = function(param) {
    var isLight = param.isLight;
    var ref = useTalentEngineFooter(), t = ref.t, onSubmit = ref.onSubmit, formMethods = ref.formMethods, isFormFilled = ref.isFormFilled, onFormFieldFocus = ref.onFormFieldFocus;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentEngineFooter_styled/* StyledWrapper */.SD, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
            name: "talentEngineForm",
            id: "talentEngineForm",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentEngineFooter_styled/* StyledContainer */.PQ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentEngineFooter_styled/* StyledHeader */.eb, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                                editorial: true,
                                children: t("talent-engine-landing.form.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "talent-engine-landing-v3",
                                    i18nKey: "talent-engine-landing.form.desc"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_Form, {})
                ]
            })
        })
    });
};
/* harmony default export */ var footer_TalentEngineFooter = (TalentEngineFooter);


/***/ }),

/***/ 463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Nav; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.constants.tsx



var NAVITEMS = function(t, asPath, locale) {
    return [
        {
            label: t("talent-engine-landing.nav.product"),
            isActive: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineSave */.uu.talentEngineSave, locale) || asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineCandidates */.uu.talentEngineCandidates, locale) || asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineHiring */.uu.talentEngineHiring, locale) || asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineInterviews */.uu.talentEngineInterviews, locale),
            options: [
                {
                    label: t("talent-engine-landing.nav.save"),
                    value: "save",
                    icon: pro_light_svg_icons/* faClock */.SZw,
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineSave */.uu.talentEngineSave, locale),
                    activeClassCondition: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineSave */.uu.talentEngineSave, locale),
                    onClick: function() {
                        return service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-sublanding-ahorra-tiempo");
                    }
                },
                {
                    label: t("talent-engine-landing.nav.candidates"),
                    value: "candidates",
                    icon: pro_light_svg_icons/* faUsers */.FVb,
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineCandidates */.uu.talentEngineCandidates, locale),
                    activeClassCondition: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineCandidates */.uu.talentEngineCandidates, locale),
                    onClick: function() {
                        return service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-sublanding-mejores-candidatos");
                    }
                },
                {
                    label: t("talent-engine-landing.nav.hiring"),
                    value: "hiring",
                    icon: pro_light_svg_icons/* faFileContract */.uqx,
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineHiring */.uu.talentEngineHiring, locale),
                    activeClassCondition: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineHiring */.uu.talentEngineHiring, locale),
                    onClick: function() {
                        return service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-sublanding-contrata-mas");
                    }
                },
                {
                    label: t("talent-engine-landing.nav.interviews"),
                    value: "interviews",
                    icon: pro_light_svg_icons/* faHeadSideHeadphones */.cAo,
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineInterviews */.uu.talentEngineInterviews, locale),
                    activeClassCondition: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineInterviews */.uu.talentEngineInterviews, locale),
                    onClick: function() {
                        return service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-sublanding-consigue-entrevistas");
                    }
                }
            ]
        },
        {
            label: t("talent-engine-landing.nav.blog"),
            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale),
            isActive: asPath === "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlog */.uu.talentEngineBlog, locale)),
            serviceEvent: function() {
                service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-blog");
            }
        },
        {
            label: t("talent-engine-landing.nav.new"),
            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlogWhatsNew */.uu.talentEngineBlogWhatsNew, locale),
            isActive: asPath === "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineBlogWhatsNew */.uu.talentEngineBlogWhatsNew, locale)),
            serviceEvent: function() {
                service_event_tracking/* default.trackLandingLinkClicked */.Z.trackLandingLinkClicked("talent-engine-menu-whats-new");
            }
        }
    ];
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/Dropdown.styled.ts
var Dropdown_styled = __webpack_require__(23211);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  background-color: ",
        ";\n  position: sticky;\n  top: 0;\n  transition: top 0.3s;\n  z-index: ",
        ";\n\n  @media (max-width: ",
        ") {\n    &.mobile {\n      display: block;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    &.desktop {\n      display: block;\n    }\n  }\n\n  .is-headroom-pinned & {\n    top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: 10px ",
        ";\n  margin: auto;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  position: relative;\n\n  > svg {\n    color: inherit;\n    width: ",
        ";\n  }\n\n  > a {\n    color: inherit;\n    transition: 0.3s;\n\n    &:hover {\n      opacity: 0.5;\n    }\n\n    &:active {\n      opacity: 0.25;\n    }\n\n    &.active {\n      color: ",
        ";\n    }\n  }\n\n  > button {\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    color: inherit;\n    font-weight: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    appearance: none;\n    cursor: pointer;\n    transition: 0.3s;\n\n    &:hover {\n      opacity: 0.5;\n    }\n\n    &:active {\n      opacity: 0.25;\n    }\n\n    &.active {\n      color: ",
        ";\n    }\n  }\n\n  ",
        " a {\n    color: ",
        ";\n    span {\n      white-space: nowrap;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: none;\n  width: 100%;\n  z-index: ",
        ";\n  overflow-x: auto;\n  padding-bottom: ",
        ";\n\n  &.active {\n    display: block;\n    position: absolute;\n    top: 3.5rem;\n    height: calc(100vh - 3.5rem);\n  }\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n  }\n\n  ",
        " {\n    position: static;\n    background-color: unset;\n    border: 0;\n    box-shadow: unset;\n    max-height: unset;\n    padding: ",
        " 0 0;\n\n    a {\n      padding: ",
        ";\n      color: ",
        ";\n    }\n\n    svg {\n      color: ",
        ";\n    }\n\n    li {\n      border-radius: ",
        ";\n\n      &:not(.active):hover {\n        background-color: unset;\n        opacity: 0.5;\n      }\n\n      &.active a,\n      &.active svg {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var StyledNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e0f37d-0"
})(_templateObject(), (0,theme/* color */.$_)("cyan_900"), (0,theme/* zindex */.Y0)("talentEngineNav"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"));
var StyledNavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e0f37d-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"));
var StyledNavLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-77e0f37d-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("lg"));
var StyledNavItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e0f37d-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("active"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("active"), Dropdown_styled/* StyledDropdown */.EI, (0,theme/* color */.$_)("text_default"));
var StyledNavTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-77e0f37d-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("text_white"));
var StyledNavMobileMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e0f37d-5"
})(_templateObject5(), (0,theme/* color */.$_)("cyan_900"), (0,theme/* zindex */.Y0)("talentEngineNav"), (0,theme/* spacing */.W0)("xl"), StyledNavItem, (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), Dropdown_styled/* StyledDropdown */.EI, (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("text_white"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_over_active"));

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shared/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(25728);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/nav/NavItem.tsx







var TENavItem = function(param) {
    var options = param.options, href = param.href, label = param.label, isActive = param.isActive, closeMobileMenu = param.closeMobileMenu, serviceEvent = param.serviceEvent, isDownload = param.isDownload;
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var menu = (0,react.useRef)(null);
    var handleCloseMenuClick = function(e) {
        if (window.matchMedia("(min-width: 1056px)").matches) {
            var ref;
            if ((ref = menu.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
                return;
            }
            setMenuOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleCloseMenuClick);
        return function() {
            document.removeEventListener("mousedown", handleCloseMenuClick);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItem, {
        ref: menu,
        children: [
            !options && href && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: isActive ? "active" : "",
                    onClick: function() {
                        closeMobileMenu ? closeMobileMenu() : null;
                        serviceEvent ? serviceEvent() : null;
                    },
                    children: label
                })
            }),
            !options && href && isDownload && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                className: isActive ? "active" : "",
                onClick: function() {
                    closeMobileMenu ? closeMobileMenu() : null;
                    serviceEvent ? serviceEvent() : null;
                },
                children: label
            }),
            !href && options && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return setMenuOpen(!menuOpen);
                        },
                        className: isActive ? "active" : "",
                        children: [
                            label,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: menuOpen ? pro_solid_svg_icons/* faCaretUp */.l1h : pro_solid_svg_icons/* faCaretDown */.eW2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        options: options,
                        isAlignLeft: true,
                        style: {
                            display: menuOpen ? "block" : "none"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NavItem = (TENavItem);

;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.tsx














var TENav = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-landing-v3").t;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, locale = ref.locale;
    var navItems = NAVITEMS(t, asPath, locale);
    var ref1 = (0,react.useState)(false), mobileMenuOpen = ref1[0], setMobileMenuOpen = ref1[1];
    var closeMobileMenu = function() {
        return setMobileMenuOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNav, {
                className: "mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavTrigger, {
                                onClick: function() {
                                    return setMobileMenuOpen(!mobileMenuOpen);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavLogo, {
                                        src: (0,paths/* getPublicPath */.A)("/images/talentEngine/talent-engine-logo.svg"),
                                        alt: "Talent Engine",
                                        width: "100",
                                        height: "16"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: mobileMenuOpen ? pro_solid_svg_icons/* faCaretUp */.l1h : pro_solid_svg_icons/* faCaretDown */.eW2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                to: "talentEngineForm",
                                href: "#talentEngineForm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                    variant: "brandTalent",
                                    sizes: "xs",
                                    as: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("talent-engine-landing.features.cta.cta")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavMobileMenu, {
                        className: mobileMenuOpen ? "active" : "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                label: t("talent-engine-landing.nav.start"),
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineLanding */.uu.talentEngineLanding, locale),
                                isActive: asPath === (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineLanding */.uu.talentEngineLanding, locale),
                                closeMobileMenu: closeMobileMenu
                            }),
                            navItems.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    label: item.label,
                                    href: item.href,
                                    options: item.options,
                                    isActive: item.isActive,
                                    closeMobileMenu: closeMobileMenu,
                                    serviceEvent: item.serviceEvent
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNav, {
                className: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavContainer, {
                    children: [
                        navItems.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                label: item.label,
                                href: item.href,
                                options: item.options,
                                isActive: item.isActive,
                                serviceEvent: item.serviceEvent
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.companies */.uu.companies, locale),
                            variant: "brandTalent",
                            sizes: "sm",
                            onClick: function() {
                                return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("talent-engine-quiero-menu");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("talent-engine-landing.features.cta.cta")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Nav = (TENav);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ f; },
/* harmony export */   "M": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&t(e,f);var o={};for(var a in e){var n=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(f.fields,a);(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8)(o,a,Object.assign(e[a]||{},{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map


/***/ }),

/***/ 33161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
/* harmony import */ var _hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57982);
var n=function(e,o){for(var n={};e.length;){var t=e[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(r){return r.errors.forEach(function(r){return e.push(r)})}),o){var c=n[a].types,f=c&&c[t.code];n[a]=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .appendErrors */ .KN)(a,o,n,s,f?[].concat(f,t.message):t.message)}e.shift()}return n},t=function(r,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(o,n){try{var a=Promise.resolve(r["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(r){return u.shouldUseNativeValidation&&(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .validateFieldsNatively */ .M)({},u),{errors:{},values:s.raw?i:r}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return null!=r.errors}(r))return{values:{},errors:(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .toNestError */ .D)(n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map


/***/ })

}]);